import { useEffect, useCallback } from 'react';
export const useOnEscapePress = ({
  onEscape
}) => {
  const handleEscape = useCallback(e => {
    if (e.key === 'Escape' && !e.defaultPrevented) {
      onEscape(e);
    }
  }, [onEscape]);
  useEffect(() => {
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [handleEscape]);
};